import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    notifications: {
      data: [],
      status: statuses.EMPTY,
    },
    notificationsNew: {
      data: [],
      status: statuses.EMPTY,
    },
    notificationsReadUpdate: {
      data: [],
      status: statuses.EMPTY,
    },
    routeMap: {
      WelcomeNotification: 'AuditLogs',
      // etc
    },
  };
};

const store = {
  namespaced: true,
  state: defaultState,
  getters: {
    notifications: (state) => state.notifications,
    notificationsNew: (state) => state.notificationsNew,
    notificationsReadUpdate: (state) => state.notificationsReadUpdate,
    routeMap: (state) => state.routeMap,
  },

  mutations,
  actions,
};

export { store, defaultState };
